import React from "react";
import { useEffect, useRef} from 'react';
import { useLocation } from "react-router-dom";
import Navbar from "../navigation/navbar";
import Footer from "../navigation/footer";
import Contact from "../navigation/footercontact";
import fondo from "../../assets/images/fondo.png";
import { motion } from "framer-motion";

// Imagenes
import S1 from "../../assets/images/S1.png";
import S2 from "../../assets/images/S2.png";
import S3 from "../../assets/images/S3.png";
import S4 from "../../assets/images/S4.jpg";

const Servicios = () => {
  
    useEffect(() => {
      // Esto hará que el scroll vuelva al inicio al montar el componente
      window.scrollTo(0, 0);
  }, []); // Dependencia vacía para que se ejecute solo una vez cuando el componente se monta

  const pageTransition = {
    initial: { opacity: 0, x: 100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
    transition: { duration: 1 }
  };
   
  return (
    <motion.div className="w-full" initial="initial"
    animate="animate"
    exit="exit"
    variants={pageTransition}>
      {/* navbar  */}
      <div className="container mx-auto">
        <Navbar />
      </div>

      {/* Hero */}
      <div className="relative w-full">
        <img
          className="absolute object-cover w-full h-64"
          src={fondo}
          alt="Fondo Landing Page"
        />
        <div className="container relative flex flex-col justify-center h-64 px-8 pt-20 mx-auto xl:px-24">
          <h1 className="text-4xl font-bold text-white">Servicios</h1>

          {/* BreadCrumb */}
          <nav class="flex pt-2" aria-label="Breadcrumb">
            <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li class="inline-flex items-center">
                <a
                  href="/"
                  class="inline-flex items-center text-sm font-normal text-white hover:text-blue-600 "
                >
                  <svg
                    class="w-3 h-3 me-2.5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
                  </svg>
                  Inicio
                </a>
              </li>
              <li>
                <div class="flex items-center">
                  <svg
                    class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 6 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 9 4-4-4-4"
                    />
                  </svg>
                  <a
                    href="/nosotros"
                    class="ms-1 text-sm text-white font-semibold hover:text-blue-600 md:ms-2 dark:text-gray-400 dark:hover:text-white"
                  >
                    Nosotros
                  </a>
                </div>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* a quien va dirigido  */}
      <div className="flex flex-col w-full md:flex-row ">
        {/* destinatarios */}
        <div className="flex flex-col justify-center md:w-1/2 p-14 bg-darkgray">
          <h2 className="py-4 text-xl font-bold text-white md:text-2xl lg:text-3xl">
            Destinatarios
          </h2>
          <p className="text-sm text-justify text-white md:text-base lg:text-lg">          
En NDT Technical Solutions Costa Rica S.A., ofrecemos nuestros servicios especializados de ensayos no destructivos a una amplia variedad de industrias que operan en entornos críticos y exigentes. Esta versatilidad nos permite atender las necesidades de sectores como la energía, la aeronáutica, la construcción, la manufactura y más, garantizando que cada proyecto reciba soluciones técnicas precisas y los más altos estándares de calidad y seguridad.
          </p>
        </div>
        {/* Tipos de aviación */}
        <div className="p-4 py-8 bg-white md:w-1/2">
          <div className="flex flex-col px-8 lg:px-14">
            <h3 className="py-4 text-2xl font-bold text-darkgray md:text-2xl lg:text-3xl">
            Abrió mercado en la industria:
            </h3>
            <div className="flex flex-col space-y-0 lg:space-x-4 lg:space-y-0 lg:flex-row">
              <div>
                <ul class="max-w-md space-y-1 mx-8 font-normal lg:text-lg text-darkgray list-disc list-inside">
                  <li>Constructora</li>
                  <li>Automotriz</li>
                  <li>Ferroviaria</li>
                  <li>Aeronáutica</li>
                  <li>Petrolera</li>
                </ul>
              </div>
              <div>
                <ul class="max-w-md space-y-1 mx-8 lg:text-lg text-darkgray list-disc list-inside">
                  <li>Atracciones Mecánicas</li>
                  <li>Plantas Hidroeléctricas</li>
                  <li>Compañías de Energía limpia</li>
                  <li>Entidades gubernamentales</li>
                  <li>Entre otros</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* soluciones y servicios */}
<div className="bg-white ">
  {/* <h2 className="py-8 text-xl font-bold text-center pt-14 text-darkgray md:text-2xl lg:text-3xl">
    Soluciones y servicios
  </h2> */}

  {/* Inspecciones y pruebas */}
  <div>
    {/* Título */}
    <h3 className="max-w-md py-4 pr-8 mt-8 text-xl font-bold text-left text-white rounded-r-full bg-gradient-to-r from-lightblue to-lightblue2 pl-14 md:text-2xl lg:text-3xl">
      Soluciones y Servicios
    </h3>

    <div className="p-8 lg:px-24">
      {/* Descripción general */}
      <div className="flex flex-col items-center space-y-8 md:space-y-0 md:space-x-12 md:flex-row">
        {/* Texto */}
        <div className="space-y-4 md:w-1/2">
          <h4 className="pb-2 pr-8 text-xl font-semibold border-b-8 w-fit md:text-2xl lg:text-3xl text-darkblue border-b-lightblue">
            Pruebas e Inspecciones Técnicas
          </h4>
          <p className="text-sm font-normal text-justify text-darkblue md:text-base lg:text-lg">
            Ofrecemos inspecciones y pruebas avanzadas con equipos de alta tecnología para asegurar la integridad y seguridad de materiales y componentes. Nuestros servicios incluyen:
            <ul className="pt-4 ml-4 space-y-4 font-medium list-disc list-inside md:ml-6">
              <li>Pruebas e Inspecciones Visuales</li>
              <li>Inspecciones Boroscópicas</li>
              <li>Rayos X (Radiografía)</li>
              <li>Inspecciones por Corrientes de Eddy</li>
              <li>Pruebas de Ultrasonido (Phase Array)</li>
              <li>Partículas Magnéticas</li>
              <li>Tintes Penetrantes</li>
              <li>Inspección de Soldaduras</li>
              <li>Análisis de Vibraciones</li>
              <li>Medición de Espesores y Corrosión con equipo ultrasónico</li>
              <li>Termografía</li>
              <li>Metalurgia</li>
              <li>Análisis de Aceite y Combustible</li>
            </ul>
          </p>
        </div>
        {/* Imagen */}
        <div className="flex items-center justify-center md:w-1/2">
          <img
            className="object-cover h-72 rounded-xl"
            src={S1}
            alt="Inspecciones y pruebas"
          />
        </div>
      </div>

      {/* Entrenamientos y Cursos */}
      <div className="flex flex-col-reverse items-center space-y-8 md:mt-14 md:space-y-0 md:space-x-12 md:flex-row">
        {/* Imagen */}
        <div className="flex items-center justify-center rounded-xl md:w-1/2">
          <img
            className="object-cover lg:px-16 pt-14 md:py-0 rounded-xl"
            src={S2}
            alt="Entrenamientos y Cursos"
          />
        </div>
        {/* Texto */}
        <div className="space-y-4 md:w-1/2">
          <h4 className="pb-2 pr-8 text-xl font-semibold border-b-8 w-fit md:text-2xl lg:text-3xl text-darkblue border-b-lightblue">
            Entrenamientos y Cursos
          </h4>
          <p className="text-sm font-normal text-justify text-darkblue md:text-base lg:text-lg">
            Ofrecemos capacitación especializada en técnicas de inspección y pruebas no destructivas para asegurar la competencia y calificación de los técnicos y profesionales en el área.
            <ul className="pt-4 ml-4 space-y-4 font-medium list-disc list-inside md:ml-6">
              <li>Certificación de procedimientos de soldadura y calificación de soldadores.</li>
              <li>Cursos y talleres de entrenamiento práctico en técnicas NDT.</li>
            </ul>
          </p>
        </div>
      </div>

      {/* Auditorías y Consultorías */}
      <div className="flex flex-col items-center mt-8 space-y-8 md:mt-14 md:space-y-0 md:space-x-12 md:flex-row">
        {/* Texto */}
        <div className="space-y-4 md:w-1/2">
          <h4 className="pb-2 pr-8 text-xl font-semibold border-b-8 w-fit md:text-2xl lg:text-3xl text-darkblue border-b-lightblue">
            Auditorías y Consultorías
          </h4>
          <p className="text-sm font-normal text-justify text-darkblue md:text-base lg:text-lg">
            Brindamos servicios de auditoría, asesoría y consultoría para optimizar procesos de inspección y control de calidad, garantizando que las operaciones cumplan con los más altos estándares de seguridad y calidad.
            <ul className="pt-4 ml-4 space-y-4 font-medium list-disc list-inside md:ml-6">
              <li>Procedimientos de Inspección y Control de Calidad.</li>
              <li>Evaluaciones técnicas y análisis de riesgos.</li>
              <li>Consultoría para mejorar los estándares de seguridad y eficiencia.</li>
            </ul>
          </p>
        </div>
        {/* Imagen */}
        <div className="flex items-center justify-center md:w-1/2">
          <img
            className="object-cover h-72 md:mt-0 rounded-xl"
            src={S3}
            alt="Auditorías y Consultorías"
          />
        </div>
      </div>

      {/* Servicios adicionales */}
      <div className="flex flex-col-reverse items-center space-y-8 md:mt-14 md:space-y-0 md:space-x-12 md:flex-row">
        {/* Imagen */}
        <div className="flex items-center justify-center md:w-1/2">
          <img
            className="object-cover mt-8 h-80 md:mt-0 rounded-xl"
            src={S4}
            alt="Servicios adicionales"
          />
        </div>
        {/* Texto */}
        <div className="space-y-4 md:w-1/2">
          <h4 className="pb-2 pr-8 text-xl font-semibold border-b-8 w-fit md:text-2xl lg:text-3xl text-darkblue border-b-lightblue">
            Servicios Especializados
          </h4>
          <p className="text-sm font-normal text-justify text-darkblue md:text-base lg:text-lg">
            Ofrecemos una variedad de servicios especializados para diversas industrias, adaptándonos a las necesidades específicas de cada cliente y asegurando una solución personalizada.
            <ul className="pt-4 ml-4 space-y-4 font-medium list-disc list-inside md:ml-6">
              <li>Pruebas destructivas y no destructivas.</li>
              <li>Asesoramiento para la selección de materiales y técnicas adecuadas.</li>
              <li>Soporte técnico y mantenimiento preventivo y correctivo.</li>
              <li>Inspección y análisis para componentes críticos de la industria.</li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>


      {/* Call to action */}
      <div className="items-center justify-center w-full text-center bg-white py-14">
        <h2 className="text-xl font-normal md:text-3xl lg:text-5xl text-darkblue">¿Te interesó alguno de nuestros Servicios?</h2>
        <h2 className="text-xl font-bold md:text-3xl lg:text-5xl text-darkblue">¡Escríbenos!</h2>
      </div>

      <Contact />
      <Footer />
    </motion.div>
  );
};

export default Servicios;
